class AccordionCustom extends HTMLElement {
  get details() {
    const details = this.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');
    return details;
  }

  connectedCallback() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (this.hasAttribute('open-by-default-on-mobile') && isMobile) {
      this.details.open = true;
    }

    if (this.hasAttribute('data-disable-on-mobile') && isMobile) return;

    // Intercepte le summary ET les liens <a> parents adjacents
    const summary = this.details.querySelector('summary');
    summary?.addEventListener('click', (e) => {
      e.preventDefault();
      this.details.open = !this.details.open;
    });

    // Intercepte le <a> parent juste avant l'accordéon
    const prevLink = this.previousElementSibling;
    if (prevLink instanceof HTMLAnchorElement) {
      prevLink.addEventListener('click', (e) => {
        e.preventDefault();
        this.details.open = !this.details.open;
      });
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}


